import styled from 'styled-components';

export const TableContainer = styled.div`
  background: ${(props) => props.theme.white};
  border-radius: 4px;
  padding: 1rem 1.5rem;
  box-shadow: ${(props) => props.theme['card-shadow-2']};
  width: 100%;
  overflow-x: auto;
`;

export const TableTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #111827;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Table = styled.table`
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-family: 'Poppins', sans-serif;
  font-size: 0.875rem;

  thead th {
    text-align: left;
    padding: 0.5rem;
    font-weight: 600;
    color: #9ca3af;
    font-size: 0.75rem;
    text-transform: uppercase;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
  }

  tbody td {
    padding: 0.5rem;
    border-bottom: 1px solid #f3f4f6;
    color: #111827;
    white-space: nowrap;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;
